<template>
  <v-container v-if="!userIsAdmin()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsAdmin()">
    <v-container>
      <h1>Gestión de Usuarios</h1>
      <v-row>
        <v-col cols="12">
          <v-btn color="secondary" @click="showForm = false" v-if="showForm">
            Volver a la Lista
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!showForm">
        <v-col cols="12">
          <UserList
            @delete="openDeleteModal"
            @newItem="newItem"
            @editItem="editItem"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <UserForm :id="itemId" @saved="saved" />
        </v-col>
      </v-row>

      <!-- Modal de confirmación para eliminar usuario -->
      <v-dialog v-model="deleteModal" max-width="400px">
        <v-card>
          <v-card-title class="headline">Confirmar eliminación</v-card-title>
          <v-card-text>
            ¿Está seguro de que desea eliminar este usuario?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteModal = false"
              >Cancelar</v-btn
            >
            <v-btn color="red darken-1" text @click="confirmDelete"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useUsersStore } from '@/stores/usersStore'
import UserList from '@/components/users/UserList.vue'
import UserForm from '@/components/users/UserForm.vue'
import { userIsAdmin } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
// import { getToken } from '@/utils/tokenStorage'
// import util from 'util';
const usersStore = useUsersStore()
const showForm = ref(false)
const itemId = ref(-1)

// Nuevas variables para el modal de eliminación
const deleteModal = ref(false)
const userToDelete = ref(null)

onMounted(async () => {
  // await loadUsers()
})

async function loadUsers() {
  try {
    await usersStore.fetchUsers({})
  } catch (error) {
    console.error('Error al cargar usuarios:', error)
  }
}

function newItem() {
  showForm.value = true
  itemId.value = 0
}

function editItem(item) {
  console.log('item', item.id, item)
  itemId.value = item.id
  showForm.value = true
}

function openDeleteModal(userId) {
  userToDelete.value = userId
  deleteModal.value = true
}

async function confirmDelete() {
  try {
    await usersStore.deleteUser(userToDelete.value)
    await loadUsers()
    deleteModal.value = false
  } catch (error) {
    console.error('Error al eliminar usuario:', error)
  }
}

async function saved() {
  showForm.value = false
  await loadUsers()
}
</script>
